import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom'

import commonComponents from "../../components/common";

import authServices from "../../services/auth";
import global from "../../config/global";
import common from "../../utils/common";

const Authenticate = () => {
  const location = useLocation();
  const { BusyOverlay } = commonComponents;

  useEffect(() => {
    loginWithToken();
  }, [])

  const loginWithToken = async () => {
    const token = common.getCsLockerToken();
    const currentPage = common.getRouterByLocation(location);

    if (token) {
      await common.updateAccessToken(token);
      if (currentPage.query?.client === 'browser') {
        window.postMessage(
          {
            command: 'cs-authResult',
            token: token
          },
          window.location.origin
        )
      }
      await authServices.locker_access_token().then(async (response) => {
        await common.updateAccessToken(response.access_token);
        global.navigate(global.keys.LOCK)
      }).catch(async () => {
        await common.updateAccessToken(null);
        global.navigate(global.keys.LOGIN);
      })
    } else {
      global.navigate(global.keys.LOGIN)
    }
  }
  return (
    <div className="auth-page items-center">
      <BusyOverlay />
    </div>
  );
}

export default Authenticate;